import { queryOptions } from '@tanstack/react-query'
import { z } from 'zod'

const versionFileSchema = z.object({
	builtAt: z.string(),
})

export const deployedBuildQueryOptions = queryOptions({
	queryKey: ['app-version'],
	queryFn: async () => {
		const response = await fetch('/version.json', { cache: 'no-store' })

		return versionFileSchema.parse(await response.json()).builtAt
	},
	retry: false,
})
